import { Box, TextField, Autocomplete } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { LoadingButton } from "@mui/lab";
import { useClients } from "Context/Clients";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ClientSearch = ({ loading }) => {
  const { fetchClientShortInfo, clientShortInfo } = useClients();
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchClientShortInfo();
  }, []);

  useEffect(() => {
    if (selectedValue) {
      navigate(`/clients/${selectedValue.Id}`);
    }
  }, [selectedValue, navigate]);

  useEffect(() => {
    if (clientShortInfo) {
      setOptions(clientShortInfo);
    }
  }, [clientShortInfo]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 2 }}>
      <Autocomplete
        sx={{ background: "white" }}
        options={options}
        size="small"
        getOptionLabel={(option) => option.Title ?? ""}
        value={selectedValue}
        disabled={loading}
        onChange={(_, newValue) => setSelectedValue(newValue)}
        renderInput={(params) => (
          <TextField {...params} label="Sök klienter" variant="outlined" />
        )}
        fullWidth
      />
      <LoadingButton
        variant="contained"
        onClick={() => navigate(`/clients/${selectedValue.Id}`)}
        disabled={loading || !selectedValue}
      >
        <SearchIcon />
      </LoadingButton>
    </Box>
  );
};

export default ClientSearch;
